export default {
    title_list: 'Оценка артефактов',
    title_page: 'Оценка артефакта',
    title_create_page: 'Создать оценку артефакта',
    title_edit_page: 'Изменить оценку артефакта',

    filter: {
        labels: {

        }
    },

    table: {
        labels: {
            id: 'ID',
            email: 'Email',
            user_id: 'Пользователь',
            artifact_id: 'Артефакт',
            paid_appraisal: 'Платная оценка',
            status_id: 'Статус',
        }
    },

    buttons: {

    },

    form: {
        email: 'Email',
        user_id: 'Пользователь',
        artifact_id: 'Артефакт',
        //active: 'Active',
        paid_appraisal: 'Интерес к платной оценке',
        status_id: 'Статус',
    },
}
